import SelectWiz from '../../../../../../../common/inputs/wizard/SelectWiz.jsx'
import PropTypes from 'prop-types'
import {JsonViewer} from '../../../../../../../common/JsonViewer.jsx'
import {HeaderTitle} from '../../../../../../../common/HeaderTitle.jsx'
import {usePozycjeSlownika} from '../../../../../../../../api/domain/slowniki/queries/usePozycjeSlownika.jsx'
import {Icons} from '../../../../../../../common/Icons.jsx'

export const Powiazania = (props) => {
    const rawStrategia = usePozycjeSlownika('strategia_rozwoju')
    const strategiaData = rawStrategia?.data || rawStrategia?.list || []
    const strategiaOptions = Array.isArray(strategiaData) ? strategiaData : (strategiaData?.list || [])

    return (
        <div>
            <JsonViewer src={props.wiz?.form || {}} show={false}/>

            <HeaderTitle noHr size={'fs-3'} title={'Powiązania projektowe'}/>
            <HeaderTitle
                noHr
                size={'fs-4'}
                title={'Wskaż powiązanie projektu ze Strategią Rozwoju Województwa Śląskiego - ŚLĄSKIE 2030'}
            />

            <div className={'d-flex align-items-center gap-1 mb-3 text-muted'}>
                <Icons.link size={14}/>
                <a
                    href={'https://bip.slaskie.pl/wojewodztwo/programy_plany_i_strategie_wojewodztwa/strategia_rozwoju/strategia-rozwoju-wojewodztwa.html'}
                    target={'_blank'}
                    rel={'noopener noreferrer'}
                    className={'small'}
                >
                    Strategia Rozwoju Województwa Śląskiego – BIP Śląskie
                </a>
            </div>

            <div className={'d-flex flex-column gap-3'}>
                <SelectWiz
                    wiz={props.wiz}
                    keyName={'strategia_rozwoju_slaskie_2030'}
                    options={strategiaOptions}
                />
            </div>
        </div>
    )
}

Powiazania.propTypes = {
    wiz: PropTypes.any,
}
